<template>
  <md-card>
    <md-card-header md-alignment="space-between">
      <h4 class="title">
        <md-icon>assignment</md-icon>
        외부 참여자
      </h4>
    </md-card-header>
    <md-card-content>

      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          회원명 <input type="text" style="width:100px;" v-model="outjoinerNm">
          <md-button class="md-info md-sm" @click="sendQuery()" style="margin-left: 2px; vertical-align: middle;"><md-icon>check</md-icon>검 색</md-button>
        </div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="eventOuterJoinerListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-warning md-sm" @click="deleteEventJoiner">
        <md-icon>person_remove</md-icon>참여자에서 제외
      </md-button>
      <md-button class="md-success md-sm" @click="downloadExcel" v-exel-btn="[5,3]" :disabled="this.pagination.total === 0">
          <md-icon>get_app</md-icon>Excel 다운로드
      </md-button>
    </md-card-actions>
  </md-card>
</template>
<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "eventOuterJoinerListComp",
  props: {
    currentDetailMode : {
      type : String,
      default : ''
    },
    modeName : {
      type : String,
      default : ''
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  watch : {
    'currentDetailMode' (n){
      if(n == this.modeName){
        this.refreshLayout()
      }
    }
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      memberHnm: null,
      eventId : null,
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 2000],
        total: 0
      }
    };
  },
  methods: {
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_EVENT_JOINER_LIST2, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.eventOuterJoinerListGrid;
      this.gridProps['columns'] = [
          {header: '성명', name: 'outjoinerNm',align: 'center', sortable: true},
          {header: '비고 1', name: 'remark1',align: 'center', sortable: true},
          {header: '비고 2', name: 'remark2',align: 'center', sortable: true},
          {header: '비고 3', name: 'remark3',align: 'center', sortable: true},
          {header: '메모', name: 'memo',align: 'center', sortable: true}
        ];
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.eventOuterJoinerListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.refreshLayout();
    },
    refreshLayout (){
      this.$refs.eventOuterJoinerListGrid.invoke("refreshLayout");
    },
    sendQuery(eventId, isInit) {
      if(eventId) this.eventId = eventId;
      if(isInit)  this.outjoinerNm = null;
      this.$refs.eventOuterJoinerListGrid.invoke("readData", 1, {'eventId':this.eventId, 'outjoinerGb' : 'Y', outjoinerNm: this.outjoinerNm});
    },

    downloadExcel() {
      this.pagination.page = 1;
      this.pagination.perPage = this.pagination.total;
      this.pagination.fileName = '외부 참여자';
      this.pagination.eventId = this.eventId;
      this.pagination.outjoinerGb = 'Y';
      kuaaApi.requestFileDownload(
          URL_CONST.EVENT_JOINER_EXCEL_DOWNLOAD,
          this.pagination,
          '외부 참여자.xlsx',
          response => {
            this.pagination.page = this.pagination.page;
            this.pagination.perPage = this.pagination.perPage;
          }
      );
    },
    deleteEventJoiner() {

      let modalOptions = {
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "확인",
        buttonsStyling: false,
        html : '저장 되었습니다.'
      };

      let checkItems = this.$refs.eventOuterJoinerListGrid.invoke('getCheckedRows');
      console.log(checkItems)
      if(checkItems.length < 1){
        modalOptions['html'] = '참여자를 선택해 주세요';
        Swal.fire(modalOptions);
        return;
      }

      let params = [];

      checkItems.forEach((obj) => {
        params.push({
          seqNo : obj['seqNo'],
          eventId : this.eventId
        })
      });

      kuaaApi.sendServer(
        URL_CONST.DELETE_EVENT_JOINER2,
        params,
        "post",
        response => {
          console.log("<<<", response);
          modalOptions['html'] = '삭제 되었습니다.';
          Swal.fire(modalOptions);
          this.$emit('refreshJoinerGrid');
          this.sendQuery();
        }
      );

    }
  }
};
</script>

<style lang="css" scoped>
</style>